import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, InputNumber, Modal, Select, Space, Table, message } from 'antd';
import client from '../../api/client';

export default function AiSafety() {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const [selected, setSelected] = useState(null);
  const [outcome, setOutcome] = useState('REVIEWED');
  const [ticketId, setTicketId] = useState(null);
  const load = useCallback(async (before) => {
    setBusy(true);
    try { const result = await client.get('/ai-safety', { params: before ? { before } : {} }); setRows(result || []); }
    catch { message.error('读取审核记录失败'); }
    finally { setBusy(false); }
  }, []);
  useEffect(() => { load(); }, [load]);
  const submit = async () => {
    setBusy(true);
    try {
      await client.post(`/ai-safety/${selected.id}/reviews`, { outcome, ticketId });
      setSelected(null); await load(); message.success('复核记录已追加');
    } catch { message.error('保存失败，请检查工单和权限'); }
    finally { setBusy(false); }
  };
  const columns = [
    { title: '事件编号', dataIndex: 'id' }, { title: '内容 / 请求编号', dataIndex: 'request_id' },
    { title: '阶段', dataIndex: 'phase' }, { title: '规则结果', dataIndex: 'decision' },
    { title: '规则版本', dataIndex: 'rule_version' }, { title: '模型配置', dataIndex: 'model_name' },
    { title: '结果来源', dataIndex: 'generation_source', render: value => ({ MODEL_ASSISTED: '采用模型建议（含规则后处理）', RULE_FALLBACK: '规则降级' }[value] || '未记录') }, { title: '内容摘要SHA256', dataIndex: 'content_sha256' }, { title: '时间', dataIndex: 'created_at' }, { title: '复核人', dataIndex: 'actor_id' },
    { title: '工单', dataIndex: 'ticket_id' },
    { title: '操作', render: (_, row) => row.phase !== 'REVIEW' && <Button onClick={() => { setSelected(row); setOutcome('REVIEWED'); setTicketId(null); }}>追加复核</Button> },
  ];
  return <Space direction="vertical" style={{ width: '100%' }}>
    <h2>AI审核记录</h2>
    <Alert type="info" showIcon message="PASS仅表示未命中当前版本规则，不代表内容已全面审核通过。此处不保存对话正文；需结合用户反馈工单核实后追加复核。" />
    <Space><Button onClick={() => load()} disabled={busy}>刷新最新</Button>
      <Button disabled={busy || rows.length < 100} onClick={() => load(rows[rows.length - 1]?.id)}>更早记录</Button></Space>
    <Table rowKey="id" columns={columns} dataSource={rows} loading={busy} pagination={false} scroll={{ x: 1300 }} />
    <Modal title="追加人工复核记录" open={!!selected} onCancel={() => setSelected(null)} onOk={submit} confirmLoading={busy}>
      <p>请选择实际已完成的处理；此操作不会自动删除内容或关闭功能。</p>
      <Space direction="vertical">
        <Select value={outcome} onChange={setOutcome} style={{ width: 260 }} options={[
          { value: 'REVIEWED', label: '已人工核查' }, { value: 'CONFIRMED_RISK', label: '确认存在风险' },
          { value: 'FALSE_POSITIVE', label: '确认规则误拦截' }, { value: 'CORRECTED', label: '已完成纠正并反馈' },
          { value: 'DISABLED', label: '已另行停用功能' },
        ]} />
        <InputNumber min={1} precision={0} placeholder="相关真实工单编号（选填）" value={ticketId} onChange={setTicketId} style={{ width: 260 }} />
      </Space>
    </Modal>
  </Space>;
}
